import * as S from "./GridRow.style";

interface GridRowProps {
  data?: any;
}

export const GridRow = ({ data }: GridRowProps) => {
  return (
    <S.GridRow>
      <S.GridData>
        <div>
          <S.GridStatusChip $status={data.status}>
            {data.status === "warn"
              ? "주의"
              : data.status === "good"
              ? "정상"
              : "위험"}
          </S.GridStatusChip>
        </div>
      </S.GridData>
      <S.GridData>{data.value}</S.GridData>
      <S.GridData>{data.label}</S.GridData>
    </S.GridRow>
  );
};
